export default "__VITE_ASSET__DCNppWQR__"